import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  ListGroup,
  ListGroupItem,
  Modal,
  OverlayTrigger,
  Panel,
  Tooltip
} from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import Loadable from 'react-loading-overlay'
import Validators from '../../utils/validators'

@observer(['activities', 'contacts', 'companies', 'globals', 'mailchimp'])
export default class Contacts extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showNewContactModal: false,
      showEditContactModal: false,
      newContactFirstName: '',
      newContactLastName: '',
      newContactTitle: '',
      newContactEmail: '',
      newContactPhone: '',
      editContactId: 0,
      editContactFirstName: '',
      editContactLastName: '',
      editContactTitle: '',
      editContactEmail: '',
      editContactPhone: '',
      selectedContact: {},
      loadableState: true,
      modalLoadableState: false
    }

    this.loadContacts(this.props.companyId)
  }

  loadContacts(companyId) {
    this.props.contacts.loadAllContactsByCompany(companyId, () => {
      this.setState({
        loadableState: false
      })
    })
  }

  //MODAL CONTROLS
  openNewContactModal() {
    this.setState({
      showNewContactModal: true
    })
  }

  closeNewContactModal() {
    this.setState({
      showNewContactModal: false,
      newContactFirstName: '',
      newContactLastName: '',
      newContactTitle: '',
      newContactEmail: '',
      newContactPhone: ''
    })
  }

  openEditContactModal(id) {
    this.props.contacts.loadContact(id, (data) => {
      this.setState({
        showEditContactModal: true,
        editContactId: data.id,
        editContactFirstName: data.firstName,
        editContactLastName: data.lastName,
        editContactTitle: data.title,
        editContactEmail: data.email,
        editContactPhone: data.phone
      })
    })
  }

  closeEditContactModal() {
    this.setState({
      showEditContactModal: false,
      editContactFirstName: '',
      editContactLastName: '',
      editContactTitle: '',
      editContactEmail: '',
      editContactPhone: ''
    })
  }

  openMailChimpModal(row) {
    this.setState({
      selectedContact: row,
      showMailChimpModal: true,
      modalLoadableState: true
    })

    this.props.mailchimp.mailchimpGetSubInfo(row.email, () => {
      this.setState({
        modalLoadableState: false
      })
    })
  }

  closeMailChimpModal() {
    this.props.mailchimp.resetMemberInfo()
    this.setState({
      selectedContact: {},
      showMailChimpModal: false
    })
  }

  //VALIDATION HANDLERS 
  validateNewContactForm() {
    if (this.getNewContactFirstNameValidationState() == 'error') {
      return false
    }

    if (this.getNewContactLastNameValidationState() == 'error') {
      return false
    }

    if (this.getNewContactEmailValidationState() == 'error') {
      return false
    }

    if (this.getNewContactPhoneValidationState() == 'error') {
      return false
    }

    if (this.getNewContactInfoValidationState() == 'error') {
      return false
    }

    return true
  }

  validateEditContactForm() {
    if (this.getEditContactFirstNameValidationState() == 'error') {
      return false
    }

    if (this.getEditContactLastNameValidationState() == 'error') {
      return false
    }

    if (this.getEditContactEmailValidationState() == 'error') {
      return false
    }

    if (this.getEditContactPhoneValidationState() == 'error') {
      return false
    }

    if (this.getEditContactInfoValidationState() == 'error') {
      return false
    }

    return true
  }

  getNewContactFirstNameValidationState() {
    if (this.state && Validators.validString(this.state.newContactFirstName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewContactLastNameValidationState() {
    if (this.state && Validators.validString(this.state.newContactLastName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewContactEmailValidationState() {
    if (Validators.validEmail(this.state.newContactEmail) || this.state.newContactEmail.length == 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewContactPhoneValidationState() {
    if (Validators.validString(this.state.newContactPhone) || this.state.newContactPhone.length == 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewContactInfoValidationState() {
    if (this.state.newContactEmail.length == 0 && this.state.newContactPhone.length == 0) {
      return 'error'
    } else {
      return 'success'
    }
  }

  getEditContactFirstNameValidationState() {
    if (this.state && Validators.validString(this.state.editContactFirstName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditContactLastNameValidationState() {
    if (this.state && Validators.validString(this.state.editContactLastName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditContactEmailValidationState() {
    if (Validators.validEmail(this.state.editContactEmail) || this.state.editContactEmail.length == 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditContactPhoneValidationState() {
    if (Validators.validString(this.state.editContactPhone) || this.state.editContactPhone.length == 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditContactInfoValidationState() {
    if (this.state.editContactEmail.length == 0 && this.state.editContactPhone.length == 0) {
      return 'error'
    } else {
      return 'success'
    }
  }

  //STATE CHANGE HANDLERS
  onNewContactFirstNameChanged(e) {
    this.setState({
      newContactFirstName: e.target.value
    })
  }

  onNewContactLastNameChanged(e) {
    this.setState({
      newContactLastName: e.target.value
    })
  }

  onNewContactTitleChanged(e) {
    this.setState({
      newContactTitle: e.target.value
    })
  }

  onNewContactEmailChanged(e) {
    this.setState({
      newContactEmail: e.target.value
    })
  }

  onNewContactPhoneChanged(e) {
    this.setState({
      newContactPhone: e.target.value
    })
  }

  onEditContactFirstNameChanged(e) {
    this.setState({
      editContactFirstName: e.target.value
    })
  }

  onEditContactLastNameChanged(e) {
    this.setState({
      editContactLastName: e.target.value
    })
  }

  onEditContactTitleChanged(e) {
    this.setState({
      editContactTitle: e.target.value
    })
  }

  onEditContactEmailChanged(e) {
    this.setState({
      editContactEmail: e.target.value
    })
  }

  onEditContactPhoneChanged(e) {
    this.setState({
      editContactPhone: e.target.value
    })
  }

  //UPDATE RECORD HANDLERS
  saveContact(e) {
    if (this.validateNewContactForm()) {
      const params = {
        companyId: this.props.companyId,
        firstName: this.state.newContactFirstName,
        lastName: this.state.newContactLastName,
        title: this.state.newContactTitle,
        email: this.state.newContactEmail,
        phone: this.state.newContactPhone
      }
      this.props.contacts.newContact(params, (data) => {
        this.props.contacts.loadAllContactsByCompany(this.props.companyId)
        this.closeNewContactModal()

        //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        //this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 12, data.addContact.id, 1, this.props.companyId)
      })
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  updateContact() {
    const params = {
      id: this.state.editContactId,
      companyId: this.props.companyId,
      firstName: this.state.editContactFirstName,
      lastName: this.state.editContactLastName,
      title: this.state.editContactTitle,
      email: this.state.editContactEmail,
      phone: this.state.editContactPhone
    }

    if (this.validateEditContactForm()) {
      this.setState({
        loadableState: true
      })

      this.props.contacts.updateContact(params, (data) => {
        //Update company in quickbooks if the default contact was updated.
        if (this.props.qbCustomerId > 0 && params.id == this.props.defaultContactId) {
          this.props.updateQuickbooksCustomer((data) => {
            if (data.quickbooksUpdateCustomer.statusCode == 200) {
              this.props.contacts.loadAllContactsByCompany(this.props.companyId, () => {
                alert('Customer successfully updated.')
                this.setState({
                  loadableState: false
                })
              })
            } else {
              alert(data.quickbooksUpdateCustomer.data.message)
              this.setState({
                loadableState: false
              })
            }
          })
        } else {
          this.props.contacts.loadAllContactsByCompany(this.props.companyId, () => {
            alert('Customer successfully updated.')
            this.setState({
              loadableState: false
            })
          })
        }
        this.closeEditContactModal()

        //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        //this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 12, data.updateContact.id, 1, this.props.companyId)
      })
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  saveDefaultContact(e) {
    this.setState({
      loadableState: true
    })

    this.props.contacts.setDefaultContactId(this.props.companyId, e, (data) => {
      if (this.props.qbCustomerId > 0) {
        this.props.updateQuickbooksCustomer((data) => {
          if (data.quickbooksUpdateCustomer.statusCode == 200) {
            this.props.contacts.loadAllContactsByCompany(this.props.companyId)
            alert('Default Contact Updated')
            this.setState({
              loadableState: false
            })
          } else {
            alert(data.quickbooksUpdateCustomer.data.message)
            this.setState({
              loadableState: false
            })
          }
        })
      } else {
        this.props.contacts.loadAllContactsByCompany(this.props.companyId)
        alert('Default Contact Updated')
        this.setState({
          loadableState: false
        })
      }
    })
    this.props.onSetDefaultContactId(e)
  }

  deleteContact(id) {
    if (confirm("Are you sure you want to delete this contact?")) {
      this.props.contacts.deleteContact(id, () => {
        alert('Contact Removed')
        this.props.contacts.loadAllContactsByCompany(this.props.companyId)

        //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        //this.props.activities.logNewActivity(localStorage.getItem('userId'), 'delete', 12, id, 1, this.props.companyId)
      })
    }
  }

  addMemberToList(params) {
    this.setState({
      modalLoadableState: true
    })

    let data = {
      email: this.state.selectedContact.email,
      firstName: this.state.selectedContact.firstName,
      lastName: this.state.selectedContact.lastName
    }

    this.props.mailchimp.addMemberToList(params.listId, data, (results) => {
      if (results.statusCode == 200) {
        alert('Email was successfully added to the list.')
        this.props.mailchimp.mailchimpGetSubInfo(data.email, () => {
          this.setState({
            modalLoadableState: false
          })
        })
      } else {
        alert(results.data.message)
        this.setState({
          modalLoadableState: false
        })
      }
    })
  }

  removeMemberFromList(params) {
    this.setState({
      modalLoadableState: true
    })

    this.props.mailchimp.removeMemberFromList(params, (results) => {
      if (results.statusCode == 200) {
        alert('Member was successfully removed from the list.')
        this.props.mailchimp.mailchimpGetSubInfo(this.state.selectedContact.email, () => {
          this.setState({
            modalLoadableState: false
          })
        })
      } else {
        alert(results.data.message)
        this.setState({
          modalLoadableState: false
        })
      }
    })
  }

  formatActions(cell, row) {
    let setDefaultButton = (<Button bsSize="small" disabled={true}><i className="fa fa-check" aria-hidden="true"></i></Button>)
    let setDeleteButton = (<Button bsSize="small" disabled={true}><i className="fa fa-trash" aria-hidden="true"></i></Button>)

    if (this.props.defaultContactId) {
      if (cell != this.props.defaultContactId) {
        setDefaultButton = (<Button bsSize="small" bsStyle="success" onClick={(e) => { this.saveDefaultContact(cell) }}><i className="fa fa-check" aria-hidden="true"></i></Button>)
        setDeleteButton = (<Button bsSize="small" bsStyle="danger" id={cell} onClick={() => { this.deleteContact(cell) }}><i className="fa fa-trash" aria-hidden="true"></i></Button>)
      }
    }


    return (<div>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'setDefaultContact-' + cell}>Set As Default</Tooltip> }>{setDefaultButton}</OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'editContact-' + cell}>Edit Contact</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={(e) => { this.openEditContactModal(cell) }}><i className="fa fa-pencil" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'addContactMailchimp-' + cell}>Add to Mailchimp</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={(e) => { this.openMailChimpModal(row) }}><i className="fa fa-maxcdn" aria-hidden="true"></i></Button></OverlayTrigger>
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'deleteContact-' + cell}>Delete Contact</Tooltip> }>{setDeleteButton}</OverlayTrigger>
    </div>)
  }

  render() {
    let subscribedInfo = ''
    let unsubscribedInfo = ''

    if (this.props.mailchimp.memberInfo.statusCode == 200) {
      subscribedInfo = (
        this.props.mailchimp.memberInfo.data.results.subscribed.length > 0
          ? this.props.mailchimp.memberInfo.data.results.subscribed.map((subscribed) => (
            <ListGroupItem>{subscribed.name} ({ subscribed.status })<Button className={'pull-right'} bsStyle="danger" bsSize="xsmall" onClick={ () => { this.removeMemberFromList(subscribed) } }>Remove</Button></ListGroupItem>
          ))
          : 'Not subscribed to any list.'
      )

      unsubscribedInfo = ( 
        this.props.mailchimp.memberInfo.data.results.unsubscribed.length > 0
          ? this.props.mailchimp.memberInfo.data.results.unsubscribed.map((unsubscribed) => (
            <ListGroupItem>{unsubscribed.name}<Button className={'pull-right'} bsStyle="success" bsSize="xsmall" onClick={ () => { this.addMemberToList(unsubscribed) } }>Add</Button></ListGroupItem>
          ))
          : 'Not unsubscribed to any list'
      )
    }

    const contactsTable = (
      <div>
        <Button bsStyle="info" onClick={this.openNewContactModal.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
        <BootstrapTable
          data={this.props.contacts.contacts}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          bordered={false}
        >
          <TableHeaderColumn width="50" dataField="id" isKey={true} dataSort={true} dataAlign="center" hiddenOnInsert={true} autoValue={true}>ID</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="fullName" dataSort={true} editable={false}>Name</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="title" dataSort={true} editable={false}>Title</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="email" dataSort={true}>Email</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="phone" editable={false} hiddenOnInsert={true} dataSort={true}>Phone</TableHeaderColumn>
          <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.formatActions.bind(this)}>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div>
        <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
          <div>
            {contactsTable}
          </div>
        </Loadable>
        <Modal show={this.state.showNewContactModal} onHide={this.closeNewContactModal.bind(this)} bsSize="small">
          <Modal.Header closeButton>
            <Modal.Title>New Contact</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newContactForm">
              <FormGroup validationState={this.getNewContactFirstNameValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="First Name" id="newContactFirstName" onChange={this.onNewContactFirstNameChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getNewContactLastNameValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Last Name" id="newContactLastName" onChange={this.onNewContactLastNameChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={12}><FormControl type="text" placeholder="Title" id="newContactTitle" onChange={this.onNewContactTitleChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getNewContactEmailValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Email" id="newContactEmail" onChange={this.onNewContactEmailChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getNewContactPhoneValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Phone" id="newContactPhone" onChange={this.onNewContactPhoneChanged.bind(this)} /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.closeNewContactModal.bind(this)}>Close</Button>
            <Button bsStyle="success" onClick={this.saveContact.bind(this)}>Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showEditContactModal} onHide={this.closeEditContactModal.bind(this)} bsSize="small">
          <Modal.Header closeButton>
            <Modal.Title>Edit Contact</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="editContactForm">
              <FormGroup validationState={this.getEditContactFirstNameValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="First Name" defaultValue={this.state.editContactFirstName} id="editContactFirstName" onChange={this.onEditContactFirstNameChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getEditContactLastNameValidationState()}>
                <Col sm={12}><FormControl type="text" placeholder="Last Name" defaultValue={this.state.editContactLastName} id="editContactLastName" onChange={this.onEditContactLastNameChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={12}><FormControl type="text" placeholder="Title" defaultValue={this.state.editContactTitle} id="editContactTitle" onChange={this.onEditContactTitleChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getEditContactEmailValidationState()}>
                <Col sm={12}><FormControl type="text" placeholder="Email" defaultValue={this.state.editContactEmail} id="editContactEmail" onChange={this.onEditContactEmailChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup validationState={this.getEditContactPhoneValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Phone" defaultValue={this.state.editContactPhone} id="editAddressZipCode" onChange={this.onEditContactPhoneChanged.bind(this)} /></Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.closeEditContactModal.bind(this)}>Close</Button>
            <Button bsStyle="success" onClick={this.updateContact.bind(this)}>Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showMailChimpModal} onHide={this.closeMailChimpModal.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>MailChimp Info</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Loadable active={this.state.modalLoadableState} spinner text='Processing your request...'>
              <Panel header="Subscribed Lists">
                <ListGroup>
                  { subscribedInfo}
                </ListGroup>
              </Panel>
              <Panel header="Unsubscribed Lists">
                <ListGroup>
                  { unsubscribedInfo }
                </ListGroup>
              </Panel>
            </Loadable>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.closeMailChimpModal.bind(this)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/contacts.js